import Echo from 'laravel-echo'
import store from '@/store'

export const initLaravelEcho = (host = '', authToken = '') => {
    window.io = require('socket.io-client');
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: host,
        auth: {
            headers: {
                Authorization: "Bearer " + authToken
            }
        }
    });
}

export const updateBearerToken = token => {
    window.Echo.connector.options.auth.headers.Authorization = 'Bearer ' + token;
    if(process.env.NODE_ENV == 'development' ){}
}

export const subscribeToPrivateChannelEvents = (channel = '', events = {}) => {

    const subscription = getPrivateLaravelSubscription(channel)

    for (let event in events) {
        subscription.listen(event, events[event])
    }

}

export const subscribeToPublicChannelEvents = (channel = '', events = {}) => {

    const subscription = getPublicLaravelSubscription(channel)

    for (let event in events) {
        subscription.listen(event, events[event])
    }

}

export const whisperOnPrivate = (channel = '', what = '', data = {}) => {
    const subscription = getPrivateLaravelSubscription(channel)
    subscription.whisper(what, data)
}

export const listenPrivateWhisper = (channel = '', what, handler = (data)=>{}) => {
    const subscription = getPrivateLaravelSubscription(channel)

    if(typeof what === 'object'){
        for (let evt in what) {
            subscription.listenForWhisper(evt, what[evt])
        }
    }else{
        subscription.listenForWhisper(what, handler)
    }

}

export const getEchoInstance = () => {

    var echoInstance

    if (!store.state.echoInstance) {
        echoInstance = window.Echo
        store.commit('setLaravelEchoInstance', echoInstance)
    } else {
        echoInstance = store.state.echoInstance
    }

    return echoInstance

}

export const getPrivateLaravelSubscription = (channel = '') => {
    return getEchoInstance().private(channel)
}

export const getPublicLaravelSubscription = (channel = '') => {
    return getEchoInstance().channel(channel)
}

export const leaveChannel = (channel = '') => {
    getEchoInstance().leave(channel)
}